document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("template-index")) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("section-animate");
          obs.unobserve(entry.target); // 🔒 stop observing after first reveal
        }
      });
    },
    {
      threshold: 0.25,
      rootMargin: "0px 0px -10% 0px" // smoother trigger
    }
  );

  document
    .querySelectorAll(".template-index .shopify-section")
    .forEach((section) => {
      if (section.querySelector("[id*='Cart-Drawer']")) return;
      observer.observe(section);
    });
});
